// libs
import $ from "jquery";

// local
import { NavigationApp } from "./apps/modules";
import {
  VisualApp,
  AccessApp,
  HomeApp,
  MenuApp,
  ConceptApp
} from "./apps/pages";
import { FontUtil } from "./utils";


$(document).ready(() => {
  new FontUtil().init();
  new NavigationApp().init();
  initContentsApp();
});

const initContentsApp = () => {
  let app = null;
  const { pathname } = location;

  if (/^\/menu\//.test(pathname)) {
    new MenuApp().init();
  } else if (/^\/visual\//.test(pathname)) {
    new VisualApp().init();
  } else if (/^\/access\//.test(pathname)) {
    new AccessApp().init();
  } else if (/^\/concept/.test(pathname)) {
    new ConceptApp().init();
  } else if (/^\/$/.test(pathname)) {
    new HomeApp().init();
  }

  if (app) {
    app.init();
  }
};



// WEBPACK FOOTER //
// ./src/js/app.js